import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import searchPlugin from '@backstage/plugin-search/alpha';

/**
 * Lazily loads the custom search page element. Extracted so the loader can be
 * exercised directly in unit tests.
 */
export const searchPageLoader = () =>
  import('./SearchPage').then(m => <m.SearchPage />);

/**
 * Overrides the default `/search` page provided by
 * `@backstage/plugin-search/alpha` with the custom JLL search layout.
 *
 * The module targets `pluginId: 'search'` and provides a page extension with
 * no name, which resolves to the id `page:search` — the same id as the
 * plugin's default page. Per the new frontend system override rules, an
 * extension provided by a module with the same id as the plugin's default
 * takes precedence, so this custom page wins.
 *
 * `routeRef: searchPlugin.routes.root` must be re-attached so the
 * `search.root` route remains resolvable. Other extensions (e.g. the home
 * page `HomePageSearchBar`) resolve this route via `useRouteRef`, and dropping
 * it on the override would break them with "No path for routeRef{search.root}".
 */
export const searchPageModule = createFrontendModule({
  pluginId: 'search',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/search',
        loader: searchPageLoader,
        routeRef: searchPlugin.routes.root,
      },
    }),
  ],
});
